import {AADSTS_CODE_FALLBACK_REGEX} from '../constants/AADSTS_CODE_FALLBACK_REGEX';
import {AADSTS_CODE_REGEX} from '../constants/AADSTS_CODE_REGEX';
import {ParsedError} from '../types/ParsedError';

export const parseErrorDescription = (errorDescription: string): ParsedError | null => {
  const decoded = decodeURIComponent(errorDescription.replace(/\+/g, ' '));

  const matchWithTrace = AADSTS_CODE_REGEX.exec(decoded);
  if (matchWithTrace) {
    return {code: matchWithTrace[1], message: matchWithTrace[2].trim()};
  }

  const matchCodeOnly = AADSTS_CODE_FALLBACK_REGEX.exec(decoded);
  if (matchCodeOnly) {
    return {code: matchCodeOnly[1], message: matchCodeOnly[2].trim()};
  }

  return null;
};
